module.exports = __webpack_public_path__ + "static/media/eve-alpaca.b39b27d7.svg";